import { makeAutoObservable } from 'mobx';
import * as React from 'react';
import { FileStateEnum, StatementCategoryModel } from '../../models';
import { UIStore } from '../UIStore';
import { FileLibrary } from './FileLibrary';

export enum ModalTypeEnum
{
	None = "None",
	StatementPreview = "StatementPreview",
	StatementSignSelector = "StatementSignSelector",
	Spinner = "Spinner",
	Error = "Error",
	Agreement = "Agreement",
	Component = "Component",
	DoSignature = "DoSignature",
	LoadSignature = "LoadSignature",
	ShowSignature = "ShowSignature",
	DeleteFormRequired = "DeleteFormRequired"
}

export enum DeleteFormCallbackEnum
{
	None = "None",
	ChangingActiveTab = "ChangingActiveTab",
	AddingFile = "AddingFile",
	DeletingFile = "DeletingFile",
	SendingCheckMail = "SendingCheckMail",
	DeletingCategory = "DeletingCategory"
}

export class ModalLibrary
{
	private uiState: UIStore;

	constructor(ui: UIStore)
	{
		this.uiState = ui;
		makeAutoObservable(this, {}, { autoBind: true });
	}

	public ShowModal: boolean = true;
	public ShowModalClose: boolean = false;
	public ModalErrorText: any = "";
	public ModalCaption: string = "Загрузка данных";
	public ShowType: ModalTypeEnum = ModalTypeEnum.Spinner;
	public RenderComponent: any;

	public ChangingActiveTab: number = 1;
	public SetChangingActiveTab(value: number) { this.ChangingActiveTab = value; }

	public AddingFile: File | null = null;
	public SetAddingFile(value: File) { this.AddingFile = value; }

	public AddingFileType: string = "";
	public SetAddingFileType(value: string) { this.AddingFileType = value; }

	public DeletingFile: FileLibrary | null = null;
	public SetDeletingFile(value: FileLibrary) { this.DeletingFile = value; }

	public DeletingFileType: string = "";
	public SetDeletingFileType(value: string) { this.DeletingFileType = value; }

	public ChangeFormAction: DeleteFormCallbackEnum = DeleteFormCallbackEnum.None;
	public SetChangeFormAction(value: DeleteFormCallbackEnum) { this.ChangeFormAction = value; }

	public DeletingCategory: StatementCategoryModel = new StatementCategoryModel();
	public SetDeletingCategory(value: StatementCategoryModel) { this.DeletingCategory = value; }

	DeleteRequired()
	{
		this.setShowModal(false);
		switch (this.ChangeFormAction)
		{
			case DeleteFormCallbackEnum.ChangingActiveTab:
				this.uiState.changeActiveTabEx(this.ChangingActiveTab);
				break;
			case DeleteFormCallbackEnum.AddingFile:
				if (!this.AddingFile) throw Error("DeleteFormRequired=>!this.AddingFile");
				this.uiState.files.AddFileLibrary(this.AddingFileType, this.AddingFile);
				break;
			case DeleteFormCallbackEnum.DeletingFile:
				if (!this.DeletingFile) throw Error("DeleteFormRequired=>!this.DeletingFile");
				this.uiState.files.DeleteFileStore(this.DeletingFileType, this.DeletingFile);
				break;
			case DeleteFormCallbackEnum.SendingCheckMail:
				this.uiState.SendCheckMailEx();
				break;
			case DeleteFormCallbackEnum.DeletingCategory:
				this.uiState.register.setSelectedServiceCategories(this.DeletingCategory, "None");
				this.uiState.files.UpdateFileTypes();
				break;
		}
	}

	setShowModal(value: boolean, showType?: ModalTypeEnum, caption?: string, text?: string)
	{
		this.RenderComponent = undefined;
		this.ShowModal = value;
		if (value && showType)
		{
			this.ShowType = showType;

			switch (showType)
			{
				case ModalTypeEnum.Agreement:
					this.ModalCaption = "Согласие на обработку персональных данных";
					break;
				default:
					if (caption) this.ModalCaption = caption;
					break;
			}

			this.ShowModalClose = showType !== ModalTypeEnum.Spinner;

			if (text) this.ModalErrorText = this.ParseBR(text);
		}
		else
		{
			this.ShowType = ModalTypeEnum.None;
			this.uiState.stat.setDownloadingSignFileState(FileStateEnum.None);
			this.uiState.stat.setDownloadingSignFileError("");
		}
	}

	ParseBR(st: string): any
	{
		const br = React.createElement("br", null);
		return st.split("<br />").map((tx, i, a) =>
		{
			if (i === (a.length - 1)) return React.createElement(React.Fragment, { key: i }, tx);
			else return React.createElement(React.Fragment, { key: i }, tx, br);
		});
	}


	ShowComponent(caption: string, component: any)
	{
		this.RenderComponent = component;
		this.ModalCaption = caption;
		this.ShowType = ModalTypeEnum.Component;
		this.ShowModalClose = true;
		this.ShowModal = true;
	}
}
